import { AfterViewInit, Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { Apiservice } from '../../../services/api.service';
import dxList from 'devextreme/ui/list';
import { HttpErrorResponse } from '@angular/common/http';

export class _CausalePosizioniSelezionate{
  idAzienda;
  idCausale: any[];
  posizioniSelezionate: any[];
}


@Component({
  selector: 'app-select-causali-posizioni',
  templateUrl: './select-causali-posizioni.component.html',
  styleUrls: ['./select-causali-posizioni.component.css']
})
export class SelectCausaliPosizioniComponent implements OnInit,AfterViewInit {
  @ViewChild('listCausali', { static: true }) listCausali: dxList;     
  @Output() emitData: EventEmitter<any> = new EventEmitter<any>();   
  selPosizioni:any[]=[];
  selCausali:any[]=[];
  myFilter:any;
  causali: any=[];
  posizioni:any=[];
  desCaus: any;
  ultimoIdCausale: any;
  ID_AziendaSelezioanta: any;
  constructor( private appService: Apiservice,) { 
    this.causali.length=0
  }
  ngAfterViewInit(): void {
    this.causali.length=0;


  

  }

  ngOnInit() {
    this.causali.length=0;
    //posizioni
    ///PosizioneCausale?idCausale=12
    //this.appService.GetApi('CausaleRifiuti').then(data=>{
     // this.causali=data;
    //})
  }
  emettiChiusuraOk(){
    alert("eeee");
    //
  }
  aggiornaForm(causali,posizioni){

  }
  aggiornaCausali(id,causali,posizioni){ // id=Azienda
   // alert("Aggiorno")
   this.causali.length=0;
   console.log("ecco come sono le posizioni ",posizioni)
   let that=this;
    if(causali) this.selCausali=causali
    if(posizioni) this.selPosizioni=posizioni

    this.ID_AziendaSelezioanta=id
//----------------------------------------------------
this.appService.SetDBLavoro(this.ID_AziendaSelezioanta).then(response => {
  this.appService.GetApi('CausaleRifiuti').then(data=>{
    this.causali=data;
    console.log("In Aggiorna le causali ",this.selCausali)
    
    this.selCausali.forEach(element=>{
      let currPosObj =  this.causali.find(t=>t.id ===element);
      if(currPosObj) currPosObj.checked=true;
      
    })
    
    setTimeout(() => {
      $(".buttonAvanzatePos").each(function( index ) {
        console.log( "eccoli "+index + ": " + this.id );
        if(that.selPosizioni[this.id] && that.selPosizioni[this.id].length>0){
          $(this).find( "i" ).css( "color", "green" );//.addClass("opzionSelect"); 
        }
    });
    }, 200);
  })

}).catch((err: HttpErrorResponse) => {
  this.appService.parseHttpErrorResponse(err);
}); // info     dashboard            
//---------------------------------------------------------
      //alert(id);
     /*
      this.appService.GetApi('CausaleRifiuti?idAzienda='+id).then(data=>{
      this.causali=data['items'];
     */ 
  }
  GetselPosizioni(idAzienda){
    return this.selPosizioni[idAzienda]

  }
  onItemClick(evt){
    evt.event.stopPropagation();
  }
  listOnSelectionChanged2(evt){
    console.log("Ho Selezionatoooooooooo ",evt)
    console.log("Ho Selezionatoooooooooo ",evt)
    //evt.addedItems
    evt.addedItems.forEach(elem=>{
      let currAziendaObj =  this.causali.find(t=>t.id ===elem.id);
      if(currAziendaObj){ 
        
        currAziendaObj.checked=true}
    })
    //evt.removedItems
    evt.removedItems.forEach(elem=>{
      let currAziendaObj =  this.causali.find(t=>t.id ===elem.id);
      if(currAziendaObj){ 
        if(currAziendaObj.id==this.ultimoIdCausale) {
          this.posizioni=[];this.desCaus='';
          //this.selPosizioni[this.ultimoIdCausale].length=0;
        }        
        currAziendaObj.checked=false}
    })
    //console.log("Ho Selezionatoooooooooo ",this.selCausali)
    //console.log("Ho Selezionatoooooooooo ",this.causali)








    //id: 3
    
  }
  plusClick23(item,evt){
    console.log("Clikkato su item ",item)
  }
 
  ListInizialized(e){
    e.component.option("selectionByClick", false);
  }
  plusClick2(item,evt){
    
    const that=this;
    //console.log("PLUS CLICK ",item)
    //item.id 
    //evt.element.id
    //opzionSelect
    //$("#"+evt.element.id).find( "i" ).css( "color", "red" );//.addClass("opzionSelect"); 
    $(".causselect").css( "color", "black" );

    $(".buttonAvanzatePos").each(function( index ) {
        console.log( "eccoli "+index + ": " + this.id );
        if(that.selPosizioni[this.id] && that.selPosizioni[this.id].length>0){
          $(this).find( "i" ).css( "color", "green" );//.addClass("opzionSelect"); 
        }
    });
      
    

    $("#"+evt.element.id).find( "i" ).addClass("causselect"); 
    $("#"+evt.element.id).find( "i" ).css( "color", "chocolate" );//.addClass("opzionSelect"); 

    console.log("Ecco Evento ",$("#"+evt.element.id))
    //evt.event.target.addClass("opzionSelect");  
    
    this.desCaus=item.descrizione
      this.appService.GetApi('PosizioneCausale?idCausale='+item.id).then(data=>{
        this.posizioni=data;
        this.ultimoIdCausale=item.id;
        //this.selPosizioni[this.ultimoIdCausale];
        console.log("Ecco le posizioni selezionate ",this.selPosizioni[this.ultimoIdCausale])
      })
      evt.event.stopPropagation();
 
  }
}
